import { TitleLabel } from '@/components/_SiteWide/TitleLabel'
import { FileTextOutlined } from '@ant-design/icons'
import { GraviButton, Vertical } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'

export function NotePopover({ order }) {
  const popoverContent = (
    <Vertical flex={1} gap={12}>
      <TitleLabel title='User'> {order.override_username}</TitleLabel>
      <TitleLabel title='Override Reason'>{order.override_reason}</TitleLabel>
    </Vertical>
  )
  return (
    <Popover styles={{ body: { minWidth: 200 } }} content={popoverContent}>
      <GraviButton size='small' theme2 icon={<FileTextOutlined />} />
    </Popover>
  )
}
